<template>
    <div class="TQ_border TQ_width_200px TQ_borderBox TQ_padding_8px TQ_inline TQ_borderRadius TQ_box_shadow2 TQ_margin_8px TQ_verticalAlignMiddle TQ_direction_ltr">

        <!-- card info -->
        <div class="TQ_grid_col_1frAuto TQ_align_initial">
            <div class="TQ_verticalAlignTop TQ_padding_2px">
                {{p_creditCard_c.udscc_cardName_s}}
            </div>

            <!-- edit card -->
            <tq-dropdown v-if="p_showDropDown_b" options-width="150px" class="TQ_direction_rtl" :ps_only-mobile-mode_b="true" :show-caret-down="false">

                <div slot="select">
                    <tq-image :pb_src_r="ass_img_threeDots" class="TQ_width_20px"/>
                </div>

                <div slot="options">

                    <!-- delete btn-->
                    <tq-loader-button :show-loader="btnLoader_b" class="TQ_width_100p">
                        <div @click="m_deleteCreditCard_f" class="TQ_padding_8px">
                            {{ ass_strings.oneWord_delete[p_system_langCode_e] }}
                        </div>
                    </tq-loader-button><br>

                    <!-- main btn -->
                    <tq-loader-button :show-loader="btnLoader_b" class="TQ_border_top TQ_width_100p" v-if="!p_mainCreditCard_b && p_creditCard_c.udscc_status_n === 0">
                        <div @click="m_defineCardAsMainCreditCard_f"  class="TQ_padding_8px">
                            {{ ass_strings.fourWords_defineAsMainCard[p_system_langCode_e] }}
                        </div>
                    </tq-loader-button>
                </div>
            </tq-dropdown>
        </div>

        <!-- card num -->
        <div class="TQ_padding_16px_0px">
            {{p_creditCard_c.udscc_cardNum_s}}
        </div>

        <!-- cardDueDate -->
        <div class="TQ_grid_col_1frAuto">

            <!-- card status -->
            <div class="TQ_align_initial TQ_grid_center">
                <div class="TQ_text_bold TQ_bg_red TQ_padding_2px TQ_borderRadius TQ_verticalAlignTop TQ_inline"
                     v-if="p_creditCard_c.udscc_status_n !== 0">
                    {{ass_strings.oneWord_invalid[p_system_langCode_e]}}
                </div>
                <div class="TQ_text_bold TQ_bg_gold TQ_padding_2px TQ_borderRadius TQ_verticalAlignTop TQ_inline"
                     v-else-if="p_mainCreditCard_b">
                    {{ass_strings.oneWord_main[p_system_langCode_e]}}
                </div>
            </div>

            <!-- card num-->
            <div class="TQ_grid_center">
                {{p_creditCard_c.udscc_m_cardDueDateFormat_s()}}
            </div>
        </div>
    </div>
</template>

<script>
import {FB_UserData, FB_UserDataSub_CreditCard} from "../../../functions/src/shareCode/Share_S_Classes";
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import TqDropdown from "@/components/basic/TqDropdown";
import {ass_img_threeDots} from "@/assets/scripts/Ass_Files";
import {
    serverPre_subUserData_creditCards_delete_f,
    serverPre_subUserData_creditCards_update_f
} from "@/scripts/Server/S_ServerPre";
import {date_nowTime_t} from "../../../functions/src/shareCode/Share_S_Date";
import TqImage from "@/components/basic/TqImage";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";

export default {
    name: "TqCreditCard",
    components: {TqLoaderButton, TqImage, TqDropdown},
    props:{
        p_creditCard_c : {
            require: true,
            type: FB_UserDataSub_CreditCard
        },
        p_mainCreditCard_b : {
            require: true,
            type: Boolean
        },
        p_system_langCode_e:{
            require: true,
            type: String,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_showDropDown_b:{
            type: Boolean,
            default: false
        },
        p_currentUserData_c:{
            type: FB_UserData,
            require: true
        },
        pe_deleteCreditCard_f:{
            type: Function
        }
    },
    data(){
        return {
            btnLoader_b : false,

            ass_strings : ass_strings,
            ass_img_threeDots : ass_img_threeDots,

        }
    },
    methods:{
        m_deleteCreditCard_f(){

            this.btnLoader_b = true

            serverPre_subUserData_creditCards_delete_f({
                userId_uid : this.p_currentUserData_c.ud_userId_uid,
                creditCard_c: this.p_creditCard_c,
                cb_f : () => {
                    if(this.pe_deleteCreditCard_f)
                        this.pe_deleteCreditCard_f(this.p_creditCard_c.udscc_m_id_s())

                    this.btnLoader_b = false
                }
            })
        },
        m_defineCardAsMainCreditCard_f(){
            this.p_creditCard_c.udscc_mainCardDate_t = date_nowTime_t()
            this.btnLoader_b = true

            serverPre_subUserData_creditCards_update_f({
                userId_uid : this.p_currentUserData_c.ud_userId_uid,
                creditCard_c: this.p_creditCard_c,
                cb_f : () => {
                    this.btnLoader_b = false
                }
            })
        },
    }
}
</script>

<style scoped>

</style>